export const notePriorityData = ["all", "low", "medium", "high"];
